__turbopack_context__.v({
  "base": "Button-module-scss-module__YsLvQG__base",
  "buttonResets": "Button-module-scss-module__YsLvQG__buttonResets",
  "disabled": "Button-module-scss-module__YsLvQG__disabled",
  "fade-in": "Button-module-scss-module__YsLvQG__fade-in",
  "isLink": "Button-module-scss-module__YsLvQG__isLink",
});
